<template>
    <div id="map" class="store-map">
    </div>
</template>

<script>
    import {Map, View} from 'ol';
    import TileLayer from 'ol/layer/Tile';
    import XYZ from 'ol/source/XYZ';
    import Stroke from 'ol/style/Stroke';
    import Style from 'ol/style/Style';
    import Vector from 'ol/source/Vector';
    import WKT from 'ol/format/WKT';
    import {defaults as defaultInteractions} from "ol/interaction";
    import VectorLayer from 'ol/layer/Vector';
    import {ScaleLine} from 'ol/control';

    export default {
        name: "StoreMap",
        props: {
            geom: String
        },

        mounted() {
            let styles = {
                'MultiPolygon': new Style({
                    stroke: new Stroke({
                        color: 'rgba(221, 096, 051, 1)',
                        width: 3
                    })
                }),
                'Polygon': new Style({
                    stroke: new Stroke({
                        color: 'rgba(221, 096, 051, 1)',
                        width: 3
                    })
                }),
                'GeometryCollection': new Style({
                    stroke: new Stroke({
                        color: 'rgba(221, 096, 051, 1)',
                        width: 3
                    })
                })
            };

            let styleFunction = function(feature) {
                return styles[feature.getGeometry().getType()]
            };

            let vectorSource = new Vector({
                features: (new WKT()).readFeatures(this.geom)
            });

            let vectorLayer = new VectorLayer({
                source: vectorSource,
                style: styleFunction
            });

            this.$nextTick(function () {
                let map = new Map({
                    target: 'map',
                    layers: [
                        new TileLayer({
                            source: new XYZ({
                                url: 'https://reportallusa.com/dyn/tile.py?mode=tile&tilemode=gmap&tile={x}+{y}+{z}&client=gtqa3GzaMe&map=siteroot/Street_Map.map'
                            })
                        }),
                        vectorLayer
                    ],
                    interactions: defaultInteractions({
                        doubleClickZoom: false,
                        keyboardPan: false,
                        keyboardZoom: false,
                        mouseWheelZoom: false,
                        dragPan: false,
                        dragRotate: false,
                        pinchRotate: false,
                        pinchZoom: false,
                        dragZoom: false
                    }),
                    controls: [],
                    view: new View({
                        center: [0, 0],
                        zoom: 2
                    })
                });

                let scaleLine = new ScaleLine();
                map.addControl(scaleLine);
                let extent = vectorLayer.getSource().getExtent();
                map.getView().fit(extent, map.getSize());
                document.onreadystatechange = () => {
                    if (document.readyState === "complete") {
                        map.updateSize();
                    }
                }
            });
        }
    }
</script>

<style scoped>
.store-map {
    height: 100%;
}
</style>
